import Pagination from "components/CommonForBoth/Pagination";
import { useState } from "react";
import { Row, Col, Card, CardBody, Badge, Button } from "reactstrap";
import { CheckCircleOutlined, EnvironmentOutlined, UserOutlined } from '@ant-design/icons';
import { BASE_URL } from "helpers/api_helper";
import { Avatar } from "antd";

const AnnouncesList = ({ announces, formatDate, openModalForAnnouncment, forAgent }) => {
    const limit = 4;

    const [currentPage, setCurrentPage] = useState(0);
    const [skip, setSkip] = useState(0);

    const totalAnnouncements = announces ? announces.length : 0;
    const totalPages = Math.ceil(totalAnnouncements / limit);
    const paginationItems = [...Array(totalPages)];

    const announcementsToShow = announces
        ? announces.slice(skip, skip + limit)
        : [];


    const handlePagination = (id) => {
        if (typeof id === "number") {
            setCurrentPage(id);
            setSkip(limit * id);
        } else if (id === "prev" && currentPage > 0) {
            setCurrentPage(currentPage - 1);
            setSkip(skip - limit);
        } else if (id === "next" && currentPage < totalPages - 1) {
            setCurrentPage(currentPage + 1);
            setSkip(skip + limit);
        }
    };

    return (
        <>
            {totalAnnouncements > 0 ? (
                <>
                    {announcementsToShow?.map((annonce) => {
                        const cleanApiUrl = BASE_URL?.replace(/\/+$/, '');
                        let url = "";
                        if (forAgent) {
                            url = null
                        } else {
                            let cleanLogo = annonce?.clubId?.logo?.replace(/\\/g, '/')?.replace(/^\/+/, '');

                            if (!cleanLogo?.startsWith('uploads/')) {
                                cleanLogo = 'uploads/' + cleanLogo;
                            }
                            url = `${cleanApiUrl}/${cleanLogo}`;
                        }


                        return (<Row key={annonce?._id} className="mb-3">
                            <Col sm={12}>
                                <Card
                                    className="shadow-sm transition-hover"
                                    style={{
                                        cursor: "pointer",
                                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                    }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.transform = "translateY(-3px)";
                                        e.currentTarget.style.boxShadow = "0 5px 15px rgba(0,0,0,0.1)";
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.transform = "none";
                                        e.currentTarget.style.boxShadow = "";
                                    }}
                                >
                                    <CardBody>
                                        <Row className="align-items-center">
                                            <Col md={8}>
                                                <h4 className="fw-bold mb-1">{annonce?.title}</h4>
                                                <small className="text-muted">{formatDate(annonce?.createdAt)}</small>
                                            </Col>
                                            <Col md={4} className="text-end">
                                                <span className="fw-bold me-2">{forAgent ? annonce?.agentId?.firstName + " " + annonce?.agentId?.lastName : annonce?.clubId?.nameFr}</span>
                                                {
                                                    url ?
                                                        <img
                                                            src={url}
                                                            alt={annonce?.clubId?.nameFr}
                                                            style={{ width: 32, height: 32, objectFit: "contain" }}
                                                        />
                                                        :
                                                        <Avatar size={32} icon={<UserOutlined />} />
                                                }

                                            </Col>
                                        </Row>
                                        <br />

                                        <Row className="mb-3">
                                            <Col md={5}>
                                                <p className="mb-1">
                                                    <strong>Position recherchée :</strong> {annonce?.position}
                                                </p>
                                                <p className="mb-1">
                                                    <strong>Catégorie d&apos;âge :</strong> {annonce?.category?.join(", ")}
                                                </p>
                                                <p className="mb-1">
                                                    <strong>Lieu :</strong> {annonce?.location}
                                                </p>
                                            </Col>
                                            <Col md={7}>
                                                {Array.isArray(annonce?.requirements) ? (
                                                    annonce?.requirements?.map((req, i) => {
                                                        let trimmedReq = req.trim();
                                                        if (trimmedReq?.endsWith(".")) {
                                                            trimmedReq = trimmedReq?.slice(0, -1);
                                                        }
                                                        return (
                                                            <p key={i} className="mb-1">
                                                                {trimmedReq}
                                                            </p>
                                                        );
                                                    })
                                                ) : typeof annonce?.requirements === "string" && annonce?.requirements?.includes(",") ? (
                                                    annonce?.requirements?.split(",")?.map((req, i) => {
                                                        let trimmedReq = req?.trim();
                                                        if (trimmedReq?.endsWith(".")) {
                                                            trimmedReq = trimmedReq?.slice(0, -1);
                                                        }
                                                        return (
                                                            <p key={i} className="mb-1">
                                                                {trimmedReq}
                                                            </p>
                                                        );
                                                    })
                                                ) : (
                                                    <p className="mb-1">{annonce?.requirements}</p>
                                                )}

                                            </Col>

                                        </Row>

                                        <Row className="align-items-end">
                                            <Col md={8}>
                                                {annonce?.benefits?.map((benif, idx) => (
                                                    <Badge
                                                        key={idx}
                                                        color="secondary"
                                                        className="me-2 py-1 px-2"
                                                        style={{ fontSize: "0.8rem" }}
                                                    >
                                                        {benif}{" "}<CheckCircleOutlined />
                                                    </Badge>
                                                ))}
                                            </Col>
                                            <Col md={4} className="text-end">
                                                <Button
                                                    color="primary"
                                                    onClick={() => openModalForAnnouncment(annonce?._id)}
                                                    className="px-5 mt-3"
                                                >
                                                    Postuler
                                                </Button>
                                                <div className="flex mt-2">
                                                    <small className="text-muted py-1 px-2">
                                                        {annonce?.applicationCount} candidatures
                                                    </small>
                                                    <small className="text-muted py-1"><EnvironmentOutlined />{" "}{annonce?.location}</small>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>)
                    }
                    )}
                    <div style={{ width: "fit-content", margin: "0 auto" }}>
                        <Pagination
                            pages={paginationItems}
                            totalItems={totalAnnouncements}
                            handlePagesnation={handlePagination}
                            currentPage={currentPage}
                            limit={limit}
                        />
                    </div>


                </>
            ) : (
                <Row>
                    <Col>
                        <div className="text-center p-5">
                            <h4>Aucune annonce disponible</h4>
                            <p>Les nouvelles annonces apparaîtront ici.</p>
                        </div>
                    </Col>
                </Row>
            )}
        </>
    );
};

export default AnnouncesList;
